import { P2GBox } from '@parcel2go/core-ui';
import { P2GChip } from '@parcel2go/core-ui';
import { P2GDate } from '@parcel2go/core-ui';
import { P2GDivider } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import MarketplaceItem from './MarketplaceItem';
import CustomerAddress from '../../smartsend/CustomerAddress';
import { DimensionAndWeightDisplay } from '../../smartsend/DimensionDisplay';
import { GetBuyerId } from '../../smartsend/item/GetBuyerId';
import ItemInstructions from '../../smartsend/item/ItemInstructions';
import MarketplaceActions from '../../smartsend/item/MarketplaceActions';
import { ItemActionType } from '../../smartsend/item/SetMarketplaceAction';
import { GetExternalTrackingNumber } from '../../../lib/helpers/SmartSendSummaryGenerator';

interface props {
  item: SmartSendItemApiModel;
  action: (action: ItemActionType, id: string) => void;
  working: boolean;
}

export function PickingListSheetRowMobile(props: props) {
  return (
    <P2GBox p={2}>
      <P2GGrid container direction="column" spacing={2}>
        <P2GGrid item>
          <P2GText variant="h5">{props.item.BookingDetails?.Reference}</P2GText>
          <P2GText component="p" colour="primary">
            <strong>{GetExternalTrackingNumber(props.item)}</strong>
          </P2GText>
        </P2GGrid>
        <P2GGrid item>
          <P2GDivider />
        </P2GGrid>
        <P2GGrid item>
          <P2GText component="p">{props.item.Recipient.Name}</P2GText>
          <CustomerAddress customer={props.item.Recipient} />
          {GetBuyerId(props.item) && <P2GChip size="small" label={GetBuyerId(props.item)} />}
          <ItemInstructions item={props.item} />
        </P2GGrid>
        <P2GGrid item>
          <P2GDivider />
        </P2GGrid>
        <P2GGrid item>
          {props.item.MarketplaceOrderLines.map((m, i) => (
            <MarketplaceItem key={`${m.Id}_${i}`} item={m} />
          ))}
        </P2GGrid>
        {props.item.BookingDetails && (
          <>
            <P2GGrid item>
              <P2GDivider />
            </P2GGrid>
            <P2GGrid item>
              <P2GGrid container>
                <P2GGrid item flexGrow={1}>
                  <P2GText>{props.item.BookingDetails.Service.Name}</P2GText>
                </P2GGrid>
                {props.item.BookingDetails.EstimatedCollectionDate && (
                  <P2GGrid item flexShrink={1}>
                    <P2GText>
                      <P2GDate date={new Date(props.item.BookingDetails.EstimatedCollectionDate)} />
                    </P2GText>
                  </P2GGrid>
                )}
                <P2GGrid item xs={12}>
                  <DimensionAndWeightDisplay dimensions={props.item.PackageDimensions} />
                </P2GGrid>
              </P2GGrid>
            </P2GGrid>
          </>
        )}
        <P2GGrid item>
          <P2GDivider />
        </P2GGrid>
        <P2GGrid item>
          <P2GGrid container spacing={2} alignItems="center" justify="space-evenly">
            <MarketplaceActions item={props.item} action={(a) => props.action(a, props.item.Id)} size="small" />
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
    </P2GBox>
  );
}
